/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enroll_Verify_TitleInputs */

const fr_totp_enroll_verify_title = /** @type {(inputs: Totp_Enroll_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie ton code`)
};

/**

* @param {Totp_Enroll_Verify_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enroll_verify_title = /** @type {((inputs?: Totp_Enroll_Verify_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enroll_Verify_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enroll_verify_title(inputs)
});